import * as React from "react";
import { observer } from "mobx-react";
import { injectIntl, InjectedIntlProps, FormattedMessage } from "react-intl";
import { RouteComponentProps, withRouter } from "react-router";
import "./UserPassword.less";
import { Form, message, Input, Button } from "antd";
import close_eyes from "../../../assets/image/close_eyes.svg";
import { consoleApi } from "../../../apiMiddleware";
import {EyeOutlined} from "@ant-design/icons/lib";

export type UserPasswordProps = InjectedIntlProps & RouteComponentProps<{ tab: string }>;

const FormItem = Form.Item;
export type UserPasswordStates = {
    isInputPassword: boolean;
    isInputPasswordConfirm: boolean;
    confirmDirty: boolean;
    isInputOldPassword: boolean,
    isLoading: boolean,
};

@observer
class UserPassword extends React.Component<UserPasswordProps, UserPasswordStates> {
    public constructor(props: UserPasswordProps) {
        super(props);
        this.state = {
            isInputPassword: true,
            isInputPasswordConfirm: true,
            isInputOldPassword: true,
            confirmDirty: false,
            isLoading: false,
        };
    }

    private handleSubmit = async (values: any): Promise<void> => {
        const { intl } = this.props;
        try {
            this.setState({ isLoading: true });
            const res = await consoleApi.user.initiativeResetPassword(values.oldPassword, values.password);
            if (res.code === 200) {
                message.success(intl.formatMessage({ id: "password-success-message" }));
                this.setState({ isLoading: false });
                this.props.history.push("/");
            } else {
                message.error(intl.formatMessage({ id: "password-fail-message" }));
            }
        } catch (err) {
            message.error(err.message);
            this.setState({ isLoading: false });
        }
    }

    public render(): React.ReactNode {
        const { intl } = this.props;
        return (
            <div className="console-content-chart-body">
                <div className="console-content-chart-box">
                    <div className="console-user-inf">
                        <Form onFinish={this.handleSubmit} className="login-form">
                            <FormItem
                                name={"oldPassword"}
                                rules={[{ required: true, message: intl.formatMessage({ id: "input-old-password" }) }]}
                            >
                                <Input.Password
                                    size={"large"}
                                    placeholder={intl.formatMessage({ id: "input-old-password" })}
                                />
                            </FormItem>
                            <FormItem
                                rules={[{ required: true, message: intl.formatMessage({ id: "input-new-password" }) },
                                    { pattern: /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,21}$/, message: intl.formatMessage({ id: "please-provide-message" }) },
                                ]}
                                name={"password"}
                                extra={<span style={{ color: "gray", fontSize: 12 }}>
                                    <FormattedMessage
                                        id="password-reset-tips"
                                    />
                                </span>}
                            >
                                <Input.Password
                                    size={"large"}
                                    placeholder={intl.formatMessage({ id: "input-new-password" })}
                                />
                            </FormItem>
                            <FormItem
                                rules={[{ required: true, message: intl.formatMessage({ id: "input-new-password-again" }) }]}
                                name={"password-confirm"}
                            >
                                <Input.Password
                                    size={"large"}
                                    placeholder={intl.formatMessage({ id: "input-new-password-again" })}
                                />
                            </FormItem>
                            <FormItem>
                                <Button
                                    size="large"
                                    type="primary"
                                    htmlType="submit"
                                    loading={this.state.isLoading}
                                    className="register-form-button">
                                    {intl.formatMessage({ id: "update-password" })}
                                </Button>
                            </FormItem>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(injectIntl(UserPassword));



// WEBPACK FOOTER //
// ./src/components/portal/userCenter/UserPassword.tsx